export function getBase(): string {
    return '/~/ui'
}

export function getServer(): string {
    return window.location.origin
}
